import { create } from 'zustand';
import { ProjectState } from '@/types';

export const useProjectStore = create<ProjectState, []>((set, get) => ({
  currentProject: null,
  actions: {
    setCurrentProject: (project) =>
      set({ currentProject: { ...project, isLoading: false, error: null } }),
    clearCurrentProject: () => set({ currentProject: null }),
    setProjectLoading: (loading) =>
      set((state) => ({
        currentProject: state.currentProject
          ? { ...state.currentProject, isLoading: loading }
          : null,
      })),
    setProjectError: (error) =>
      set((state) => ({
        currentProject: state.currentProject ? { ...state.currentProject, error } : null,
      })),
  },
}));
